import { CLEAR_STATE, GET_TRANSACTIONS } from '../../@jumbo/constants/ActionTypes';
import IotMonitorUtils from 'util/IotMonitorUtils';

const INIT_STATE = {
  transactions: {
    data: [],
    flattenedData: [],
    totalCount: 0,
  },
};

export default (state = INIT_STATE, action) => {
  switch (action.type) {
    case CLEAR_STATE: {
      return INIT_STATE;
    }

    case GET_TRANSACTIONS: {
      return {
        ...state,
        transactions: {
          ...state.transactions,
          data: action.payload.data,
          flattenedData: action.payload.data.map(transactions => IotMonitorUtils.flattenObject(transactions)),
          totalCount: action.payload.count,
        },
      };
    }

    default: {
      return state;
    }
  }
};
